import {Component, Input} from '@angular/core';
import {WorkstationConfiguration} from "../../../../../../services/back/workstation-configuration.service";
import {DesignSystemModule} from "../../../../../design-system/design-system.module";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {ChipsModule} from "../../../../../global/chips/chips/chips.module";
import {CopyTextModule} from "../../../../../global/input/copy-text/copy-text.module";

@Component({
  selector: 'app-workstation-information',
	imports: [
		DesignSystemModule,
		CommonModule,
		TranslateModule,
		ChipsModule,
		CopyTextModule
	],
  templateUrl: './workstation-information.component.html',
  styleUrl: './workstation-information.component.scss'
})
export class WorkstationInformationComponent {
	@Input() workstation: WorkstationConfiguration;

	isEllipsisActive(e: HTMLElement): boolean {
		return (e.offsetWidth < e.scrollWidth);
	}
}
